import BaseFeature from '../../foundation/base/base';

export default class ModalTrigger extends BaseFeature {
	constructor(element) {
		super(element);
		this.addEventListeners();
	}

	addEventListeners() {
		this.addEventListener(this.element, 'click', (e) => {
			e.preventDefault();
			const target = this.element.getAttribute('data-target');
			let fullscreen = false;
			let nopadding = false;
			let title = '';
			let closeBtn = true;
			let fixed = false;

			if (this.element.getAttribute('data-fullscreen')) {
				fullscreen = this.element.getAttribute('data-fullscreen');
			}

			if (this.element.getAttribute('data-nopadding')) {
				nopadding = this.element.getAttribute('data-nopadding');
			}

			if (this.element.getAttribute('data-close')) {
				closeBtn = (this.element.getAttribute('data-close') === 'true');
			}

			if (this.element.getAttribute('data-title')) {
				title = this.element.getAttribute('data-title');
			}

			if (this.element.getAttribute('data-fixed')) {
				fixed = this.element.getAttribute('data-fixed');
			}

			this.log(`Open Modal ${target}.`, closeBtn);

			this.publish('/modal/open', {
				target,
				title,
				fullscreen,
				nopadding,
				closeBtn,
				fixed
			});
		});
	}

	removeEventListeners() {
		this.removeEventListener(this.element, 'click');
	}

	cleanup() {
		this.removeEventListeners();
	}
}

